import { Action, Reducer } from 'redux';

export interface IInititalState {
  waiting?: boolean;
  notwait?: boolean;
  sessionIsExpiring?: boolean;
  //properties...
}

export const initialState: IInititalState = {
  waiting: false,
  notwait: false,
  sessionIsExpiring: false,
  //properties...
}

export enum ActionType {
  //types...
  SetWaiting,
  SetNotWait,
  SetSessionIsExpiring
}

export interface IDispatchAction extends Action<ActionType> {
  payload: Partial<IInititalState>
}

const reducer: Reducer<IInititalState, IDispatchAction> = (state = initialState, action) => {
  if (action.type === ActionType.SetWaiting) {
    return { ...state, waiting: action.payload.waiting }
  } else if (action.type === ActionType.SetNotWait) {
    return { ...state, notwait: action.payload.notwait }
  } else if (action.type === ActionType.SetSessionIsExpiring) {
    return { ...state, sessionIsExpiring: action.payload.sessionIsExpiring }
  } else {
    return state
  }
}

export default reducer